import { BlogArticlePage } from "@/components/blog/blog-pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/title/blog/$slug")({
  component: TitleBlogArticle,
});

function TitleBlogArticle() {
  const { slug } = Route.useParams();
  return <BlogArticlePage portal="title" basePath="/title/blog" slug={slug} />;
}
